/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcRemoveCircleRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M7.555 11.1a.9.9 0 1 0 0 1.8h8.89a.9.9 0 0 0 0-1.8z" />
      <path
        fillRule="evenodd"
        d="M12 1.1C5.98 1.1 1.1 5.98 1.1 12S5.98 22.9 12 22.9 22.9 18.02 22.9 12 18.02 1.1 12 1.1M2.9 12a9.1 9.1 0 1 1 18.2 0 9.1 9.1 0 0 1-18.2 0"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcRemoveCircleRegular;
